module.exports = __webpack_public_path__ + "img/humaidlogo.2993a847.png";